export const testimonials = [
  {
    name: 'Philippe Durand',
    location: 'Directeur • Genève',
    rating: 5,
    comment: 'Service impeccable pour notre transfert vers Courchevel. Le chauffeur nous attendait à l\'aéroport avec une pancarte, véhicule Mercedes impeccable et conduite très professionnelle malgré les conditions hivernales.'
  },
  {
    name: 'Sophie Martin',
    location: 'Architecte • Lyon',
    rating: 5,
    comment: 'Nous avons utilisé le service pour un transfert familial vers Megève. Le Van Mercedes était spacieux, nos skis et bagages ont été parfaitement rangés. Conduite sécurisée en montagne, nous recommandons vivement.'
  },
  {
    name: 'Laurent Mercier',
    location: 'Entrepreneur • Lausanne',
    rating: 5,
    comment: 'Excellent service de bout en bout. Réservation facile, communication claire, véhicule luxueux et chauffeur très courtois. Le trajet Genève-Verbier s\'est déroulé dans les meilleures conditions.'
  },
  {
    name: 'Isabelle Rousseau',
    location: 'Médecin • Annecy',
    rating: 5,
    comment: 'Impressionné par la maîtrise du chauffeur sur les routes enneigées. Il connaissait parfaitement l\'itinéraire vers Val d\'Isère et nous a donné d\'excellents conseils sur la station. Service haut de gamme.'
  },
  {
    name: 'Marc Fontaine',
    location: 'Concierge Luxe • Genève',
    rating: 5,
    comment: 'Nous utilisons ce service régulièrement pour nos clients VIP. Toujours à l\'heure, véhicules impeccables, chauffeurs professionnels. C\'est notre partenaire de confiance pour les transferts alpins.'
  },
  {
    name: 'Caroline Blanc',
    location: 'Avocate • Lyon',
    rating: 5,
    comment: 'Du début à la fin, tout était parfait. Véhicule Mercedes Classe E d\'une propreté irréprochable, chauffeur ponctuel et discret. Le trajet vers Chamonix fut très agréable. Je recommande sans hésitation.'
  }
];